<template>
    <b-container fluid> 
        <b-row>
            <!-- btn-cadastrar nova chave de api e modal -->
            <div id="criarNovaChaveApi" @click="NovaChaveApi" class="add-button"  
                v-b-popover.hover.top="'Adicionar nova chave de Api.'">
                <i class="fas fa-plus"></i>
            </div>

            <!-- MODAL CADASTRO DE API -->
            <!-- SALVAR / EDITAR -->
            <b-modal id="modal-chave-api"
                ref="modalChaveApi"
                title="Cadastro de Chave Api"
                size="lg"
                no-close-on-esc
                no-close-on-backdrop
                scrollable
                v-drag>
                <el-form v-loading="modalLoading" class="geral-form" ref="formChaveApi" :model="model" :rules="rules" size="small" label-position="top">
                    <el-form-item label="Nome" prop="nome" required>
                        <el-input v-model="model.nome"></el-input>
                        <span class="helper">
                            Informe o nome do fornecedor que você irá compartilhar a chave da API. Essa informação é importante para que no futuro você saiba quem tem acesso aos seus dados.
                        </span>
                    </el-form-item>
                    <el-form-item label="Tipo de acesso da API">
                        <el-radio-group v-model="model.acessoTotal">
                            <el-radio :label="true">Acesso total para todas as ações liberadas em nossa API Pública</el-radio>
                            <el-radio :label="false">Acesso apenas para alguns recursos selecionados</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="Chave" v-if="model.tokenVisible">
                        <el-input  v-model="model.tokenVisible" disabled></el-input>
                        <span class="helper">
                            Esse é o token de autenticação da sua API. Por segurança não iremos mostrar o conteúdo completo. Caso você tenha perdido esse token, será necessário gerar um novo.
                        </span>
                    </el-form-item>
                    <el-form-item label="Autorizações" v-show="model.acessoTotal === false">
                        <div class="regras-autorizacao" v-for="auth in montagemAuths" :key="auth.name">
                            <el-checkbox class="checkall-regras" :indeterminate="indeterminate[auth.name]" v-model="checkall[auth.name]" @change="(...arg) => handleCheckAllChange(auth,...arg)"><h4>{{ auth.name }}</h4></el-checkbox>
                            <el-checkbox-group 
                                class="autorizacao-grupo"
                                v-model="model.auths[auth.name]"
                                @change="(...arg) => handleGroupChange(auth.name, auth.action.length, ...arg)">
                                <el-checkbox v-for="act in auth.action" :label="act" :key="act">{{ act }}</el-checkbox>
                            </el-checkbox-group>
                            
                        </div>
                    </el-form-item>
                    <el-form-item :label="model.ativo ? 'Ativo' : 'Inativo'" prop="ativo">
                        <el-switch v-model="model.ativo" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </el-form-item>
                </el-form>
                <template #modal-footer>
                    <div class="float-right">
                        <el-button size="small" @click="fecharModal()">Fechar</el-button>
                        <el-button size="small" type="primary" @click="salvarChaveApi" :loading="modalLoading">Salvar</el-button> 
                    </div>
                </template>
            </b-modal>


            <b-modal id="modal-chave-apitoken"
                ref="modalChaveApiToken"
                title="Sua chave de acesso para a API:"
                size="md"
                no-close-on-backdrop
                scrollable>
                <el-form class="geral-form" size="small" label-position="top">
                    <el-alert
                        title="Essa é a chave privada que dará acesso às API's do Painel F360. Salve essa chave em um local seguro, pois não iremos exibi-la novamente. Compartilhe a chave apenas com pessoas de confiança, pois com ela será possível acessar os dados das API's do Painel F360."
                        type="info"
                        show-icon>
                    </el-alert>
                    <el-form-item label="Chave">
                        <el-input class="clipboard-api" v-model="model.chaveApi" disabled>
                            <el-button slot="append" type="primary" icon="el-icon-s-order" v-clipboard="() => model.chaveApi" v-b-tooltip.click="'Chave copiada!'"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
                <template #modal-footer="{ hide }">
                    <div class="float-right">
                        <el-button size="small" @click="hide()">Fechar</el-button>
                    </div>
                </template>
            </b-modal>
        </b-row>

        
        <b-row><!-- Conteudo da pagina - tabela -->
            <div class="col-lg-12 col-md-12 mt-2 chave-api-content">
                <container-card fixed id="cadastroDeChavesApi" icon="fa-key-skeleton" title="Chaves de Apis cadastradas.">
                    <b-card header-tag="header">
                        <el-table
                            id="tableChaveApis"
                            v-loading="loadListaApis"
                            :data="tableData"
                            :default-sort = "{ prop: 'createdAt', order: 'descending'}"
                            style="width: 100%"
                            class="p-table"
                            stripe
                            border
                            size="mini">
                            <div slot="empty" style="width: 100%;">
                                Sem apis cadastradas
                            </div>
                            <el-table-column
                                fixed
                                prop="nome"
                                label="Nome"
                                sortable>
                            </el-table-column>
                            <el-table-column
                                fixed="right"
                                label="Ativo"
                                width="60"
                                align="center">
                                <template slot-scope="scope" v-if="scope.row">
                                    <el-tooltip v-if="scope.row.ativo" class="item" effect="dark" content="Status: Ativo" placement="top-start">
                                        <i class="fas fa-circle text-success"></i>
                                    </el-tooltip>
                                    <el-tooltip v-if="!scope.row.ativo" class="item" effect="dark" content="Status: Inativo" placement="top-start">
                                        <i class="fas fa-circle text-danger"></i>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            
                            <el-table-column
                                fixed="right"
                                label="Operações"
                                width="120">
                                <template slot-scope="scope" v-if="scope.row">
                                    <el-button class="mr-1 cursor-pointer" icon="el-icon-edit-outline" circle size="mini" type="primary" v-b-modal.modal-chave-api @click.native="editarChaveApi(scope.$index, scope.row)"></el-button>
                                    <el-popover
                                        placement="top"
                                        width="250"
                                        :ref="`deletePop_${scope.$index}`">
                                        <p>Tem certeza que deseja deletar esse registro ?</p>
                                        <div style="text-align: right; margin: 0">
                                            <el-button type="secundary" size="mini" @click="deletarApiOptOut(scope.$index)">Não</el-button>
                                            <el-button type="danger" size="mini" @click.native="deletarApiOpt(scope.$index, scope.row)">Sim</el-button>
                                        </div>
                                        <el-button class="cursor-pointer" slot="reference" icon="el-icon-delete" circle size="mini" type="danger"></el-button>
                                    </el-popover>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-footer class="text-center" style="padding-top:13px;">
                            <el-button class="float-right" circle @click="listaChaveApi"
                            style="position: absolute;bottom: 17px;right: 15px;"
                            v-b-popover.hover.top="'Recarregar Chaves.'">
                                <i class="fas fa-sync-alt"></i>
                            </el-button>
                        </el-footer>
                    </b-card>
                </container-card>
            </div>
        </b-row>
    </b-container>
</template>
<script>
import ContainerCard from '@/components/shared/ContainerCard'
import { clipboard } from 'vue-clipboards'
import axios from 'axios'

const model = () => {
    return {
        nome: '',
        acessoTotal: true,
        auths: {},
        chaveApi: '',
        tokenVisible: '',
        ativo: true
    }
}
const checkboxEstrutura = (auths) => {
    if(!auths){ return }

    
    const valores = {};

    auths.forEach((item) => {
        valores[item.name] = false; 
    });
    return valores;
}

export default {
    name: 'ChaveApi',
    components: {
        ContainerCard
    },
    directives: {
        clipboard
    },
    data(){
        return {
            windowHeight: 0,
            tableHeight: window.innerHeight - 277,
            tableData: [],
            montagemAuths: [],
            model: model(),
            loadListaApis: false,
            modalLoading: false,
            loadRegras: false,
            rules: {
                nome: [{ required: true, message: 'Nome é um campo obrigatório!', trigger: 'blur' }]
			},
            checkall: {},
            indeterminate: {}
        }
    },
    methods: {
        formatarAuths(dt,isMock) { // formata valores de regra para back/front 
            if(dt && dt.length){
                dt.forEach((value) => {
                    this.model.auths[value.name] = isMock ? [] : value.action;
                });
                return;
            }else{
                const autentication = Object.entries(this.model.auths);
                if(!autentication){ return }

                let Auths = [];
                autentication.forEach(([key, value]) => {
                    Auths.push({
                        name: key,
                        action: value
                    });
                });

                return Auths;
            }
        },
        handleCheckAllChange(config,val) {
            if(val) {
                this.model.auths[config.name] = config.action
            }else {
                this.model.auths[config.name] = []
            }
            
            this.indeterminate[config.name] = false;
        },
        handleGroupChange(name, range) {
            let checkedCount = this.model.auths[name].length;
            this.checkall[name] = checkedCount === range;
            this.indeterminate[name] = checkedCount > 0 && checkedCount < range;
        },
        NovaChaveApi(){
            // zera valores ao inicializar 
            this.$bvModal.show('modal-chave-api')

            this.model = model();
            this.formatarAuths(this.montagemAuths, true);
            this.checkall = checkboxEstrutura(this.montagemAuths);
            this.indeterminate = checkboxEstrutura(this.montagemAuths);
        },
        mostrarChaveApi(chave) {
            this.model.chaveApi = chave;
            this.$root.$emit('bv::hide::tooltip')
            this.$bvModal.show('modal-chave-apitoken')
        },
        salvarChaveApi() { // VALIDAÇÃO DE FORM
            const ctx = this
            // validação
            ctx.$refs['formChaveApi'].validate((valid) => {
                if (!valid) {
					ctx.$notify.error({
						title: 'Validação',
						message: `Por favor, preencha todos os campos obrigatórios`,
						position:'top-left'
					});
					return;
				}

                // salvar
                ctx.salvarRequest();
            });
        },
        fecharModal() { // limpa model e fecha modal
            this.model = model()
            this.formatarAuths(this.montagemAuths, true);
            this.checkall = checkboxEstrutura(this.montagemAuths);
            this.indeterminate = checkboxEstrutura(this.montagemAuths);
            this.$refs.modalChaveApi.hide();
        },
        listaChaveApi(){ 
            this.requestListaApis();
        },
        editarChaveApi(index, row){
            const ctx = this
            ctx.model = model();
            ctx.formatarAuths(ctx.montagemAuths, true);
            ctx.modalLoading = false;
            ctx.loadListaApis = false;

            ctx.requestEditar(index, row)

        },
        deletarApiOptOut(index){
            this.$refs['deletePop_'+index].showPopper = false
        },
        deletarApiOpt(index, row){
            this.requestDeletarApi(index,row);
        },
        // requests async
        async obterRegrasDoSistema() {
            this.loadRegras = true;
            const response = await axios.get(`${process.env.VUE_APP_ROOT_API_EXTERNA}/api/v1/Assembly/pegar-endpoints`, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            this.loadRegras = false;

            if (response.status !== 200){
                return;
            }

            this.montagemAuths = response.data;
            this.formatarAuths(response.data, true);
            this.checkall = checkboxEstrutura(this.montagemAuths);
            this.indeterminate = checkboxEstrutura(this.montagemAuths);
        },
        async salvarRequest() {
            const ctx = this;
            const modelEnvio = Object.assign({}, ctx.model);
            delete modelEnvio.chaveApi;

            modelEnvio.auths = modelEnvio.acessoTotal ? [] : ctx.formatarAuths();
            
            ctx.modalLoading = true;

            try {
                var response = ''
                if(modelEnvio.id){
                    response = await this.axios.put(this.$urls.EDITAR_CHAVE_API,modelEnvio);
                }else{
                    response = await this.axios.post(this.$urls.CRIAR_CHAVE_API,modelEnvio);
                }
            
                if(response.status !== 200) {
                    return;
                }
                ctx.fecharModal();
                ctx.listaChaveApi();
                if(!modelEnvio.id && response.data) {
                    ctx.mostrarChaveApi(response.data.tokenHash);
                }
                
            }catch(err) {
                console.log(err);
                ctx.modalLoading = false;
                ctx.$notify.error({
                    title: 'Atenção',
                    message: `Ocorreu algum erro na operação!`,
                    position:'top-left'
                });
            }
        },
        async requestListaApis() {
            this.loadListaApis = true

            let response = await this.axios.get(this.$urls.LISTA_CHAVE_API);
            
            this.loadListaApis = false;
        

            if(response.status !== 200) {
                this.$notify.error({
                    title: 'Atenção',
                    message: `Ocorreu algum erro ao carregar sua lista de Apis!`,
                    position:'top-left'
                });
                return;
            }

            this.tableData = response.data;
        },
        async requestEditar(index, row) {
            let response = await this.axios.get(`${this.$urls.GET_CHAVE_API}?id=${row.id}`);
        

            if(response.status !== 200) {
                this.$notify.error({
                    title: 'Atenção',
                    message: `Ocorreu algum erro ao carregar dados!`,
                    position:'top-left'
                });
                return;
            }
            const data =  response.data;
            this.formatarAuths(data.auths);
            const Auths = Object.assign({}, this.model.auths);
            
            this.model = data;
            this.model.auths = Auths;
            
        },
        async requestDeletarApi(index, row) {
            let response = await this.axios.delete(`${this.$urls.DELETAR_CHAVE_API}?id=${row.id}`);

            if(response.status !== 200) {
                this.$notify.error({
                    title: 'Atenção',
                    message: `Ocorreu algum erro ao deletar a Api selecionada!`,
                    position:'top-left'
                });
                return;
            }

            this.$refs['deletePop_'+index].showPopper = false
            this.listaChaveApi();
        }
    },
    watch: {
        windowHeight(newHeight) {
            this.tableHeight = newHeight - 277
        },
        'model.auths': {
            handler(auths){
                // add lógica para indeterminate
                const autentication = Object.entries(auths);
                if(!autentication){ return }

                autentication.forEach(([key, value]) => {
                    if(value.length) {
                        this.montagemAuths.forEach((item) => {
                            if(item.name === key){
                                this.handleGroupChange(key, item.action.length);
                            }
                        });
                    }
                });
            },
            deep:true
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.windowHeight = window.innerHeight
            });
        })

        this.listaChaveApi();
        this.obterRegrasDoSistema();
    },
}
</script>
<style>
    .add-button{
        width: 51px;
        padding: 14px 0;
        background: #343a40;
        color: #fff;
        text-align: center;
        border-radius: 50%;
        position: fixed;
        z-index: 10;
        cursor: pointer;
        bottom: 6px;
        margin-left: 3px;
    }
    .regras-autorizacao {
        background: #f4f4f4;
        padding: 5px 20px;
        border-radius: 5px;
    }
    .regras-autorizacao .checkall-regras {
        border-bottom: 1px solid #c6c6c6;
        padding: 0;
        display:block;
    }
    .regras-autorizacao h4 {
        font-size: 15px;
        font-weight: bold;
    }
    .regras-autorizacao .autorizacao-grupo {
        padding-left: 15px;
    }
    .regras-autorizacao .autorizacao-grupo  label {
        line-height: 0;
    }
    .clipboard-api .el-input-group__append {
        background: #3f84cb;
        color: #fff;
    }
</style>